import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";

interface SuccessResponseData {
	success: boolean;
	message: string;
}

export type ILogoutResponse = IResponse<SuccessResponseData>;

export async function logout(): Promise<ILogoutResponse> {
	return await apiRequest<SuccessResponseData>({
		path: "/api/v1/auth/logout",
		method: "POST",
	});
}

